import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    List,
    ListItem,
    ListItemText
} from '@mui/material';
import { WelcomeBoardLayout } from '../../../../common/interfaces';
import { EXAMPLE_LAYOUTS } from '../constants';
import { parseGridTemplate } from '../utils';

interface ExampleLayoutsDialogProps {
    open: boolean;
    onClose: () => void;
    onLoadLayout: (layout: WelcomeBoardLayout) => void;
}

export const ExampleLayoutsDialog: React.FC<ExampleLayoutsDialogProps> = ({
    open,
    onClose,
    onLoadLayout
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>Load Example Layout</DialogTitle>
            <DialogContent>
                <List>
                    {EXAMPLE_LAYOUTS.map((exampleLayout, index) => (
                        <ListItem
                            key={index}
                            button
                            onClick={() => onLoadLayout(exampleLayout)}
                            sx={{
                                border: '1px solid',
                                borderColor: 'divider',
                                borderRadius: 1,
                                mb: 1,
                                '&:hover': {
                                    backgroundColor: 'action.hover'
                                }
                            }}
                        >
                            <ListItemText
                                primary={exampleLayout.name}
                                secondary={`${parseGridTemplate(exampleLayout.gridColumnsTemplate)}×${parseGridTemplate(exampleLayout.gridRowsTemplate)} grid with ${exampleLayout.welcomeBoardItems.length} widgets`}
                            />
                        </ListItem>
                    ))}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};